"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.bannerPropTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rebass = require("rebass");

var _Link = _interopRequireDefault(require("../Link"));

var _Banner = require("./Banner.style");

var Banner = function Banner(_ref) {
  var image = _ref.image,
      label = _ref.label,
      position = _ref.position,
      size = _ref.size,
      textSize = _ref.textSize,
      textColor = _ref.textColor,
      useProgressiveImage = _ref.useProgressiveImage,
      url = _ref.url,
      rest = _objectWithoutProperties(_ref, ["image", "label", "position", "size", "textSize", "textColor", "useProgressiveImage", "url"]);

  var mediaProps = _objectSpread(_objectSpread({}, image), {}, {
    mediaType: 'image'
  });

  var imgSrc;

  if (image) {
    imgSrc = image.fluid ? image.fluid.src : image.src;
  } else {
    imgSrc = null;
  }

  var imageBanner = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, image && (useProgressiveImage ? /*#__PURE__*/_react.default.createElement(_Banner.BannerImage, Object.assign({
    textSize: textSize,
    size: size
  }, mediaProps)) : /*#__PURE__*/_react.default.createElement(_Banner.BannerWithoutGatsbyImage, Object.assign({
    textSize: textSize,
    size: size,
    src: imgSrc
  }, mediaProps))));

  return /*#__PURE__*/_react.default.createElement(_Banner.Wrapper, Object.assign({
    position: position
  }, rest), /*#__PURE__*/_react.default.createElement(_rebass.Box, null, label && /*#__PURE__*/_react.default.createElement(_Banner.BannerText, {
    textSize: textSize,
    textColor: textColor
  }, label)), url ? /*#__PURE__*/_react.default.createElement(_Link.default, Object.assign({
    to: url,
    enhanced: true
  }, rest), imageBanner) : imageBanner);
};

var bannerPropTypes = {
  image: _propTypes.default.shape({
    fluid: _propTypes.default.shape({
      src: _propTypes.default.string
    }),
    src: _propTypes.default.string
  }),
  label: _propTypes.default.string,
  position: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end']),
  size: _propTypes.default.oneOf(['small', 'regular', 'large']),
  textSize: _propTypes.default.oneOf(['small', 'large']),
  textColor: _propTypes.default.oneOf(['dark', 'light']),
  useProgressiveImage: _propTypes.default.bool,
  url: _propTypes.default.string
};
exports.bannerPropTypes = bannerPropTypes;
Banner.propTypes = bannerPropTypes;
Banner.defaultProps = {
  label: '',
  image: null,
  position: 'flex-start',
  size: 'regular',
  textSize: 'small',
  textColor: 'dark',
  useProgressiveImage: true,
  url: null
};
var _default = Banner;
exports.default = _default;